import React from 'react'
import Portfolio from '../components/Portfolio'
import MainLayout from './MainLayout'


export default function Home() {
  return (
    <>
      <MainLayout>
        <Portfolio />
      </MainLayout>
    </>
  )
}
